import React from 'react';

const DrawerIcon = ({ isOpen, isHovered, onClick, className, style }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            className={className}
            style={{ cursor: 'pointer', transition: 'all 0.3s ease', ...style }}
        >
            {isOpen ? (
                // X icon when open
                <>
                    <line
                        x1="6"
                        y1="6"
                        x2="18"
                        y2="18"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        style={{ transition: 'all 0.3s ease' }}
                    />
                    <line
                        x1="18"
                        y1="6"
                        x2="6"
                        y2="18"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        style={{ transition: 'all 0.3s ease' }}
                    />
                </>
            ) : (
                // Drawer icon - left panel with three lines, right panel empty
                <>
                    {/* Main rectangle with rounded corners */}
                    <rect
                        x="3"
                        y="5"
                        width="18"
                        height="14"
                        rx="2"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        fill="none"
                    />
                    {/* Vertical divider line */}
                    <line
                        x1="9"
                        y1="5"
                        x2="9"
                        y2="19"
                        stroke="currentColor"
                        strokeWidth="1.5"
                    />
                    {/* Left panel - filled on hover */}
                    <rect
                        x="3"
                        y="5"
                        width="6"
                        height="14"
                        rx="2"
                        fill={isHovered ? 'currentColor' : 'none'}
                        fillOpacity={isHovered ? 1 : 0}
                        style={{ transition: 'fill-opacity 100ms cubic-bezier(0.4, 0, 0.2, 1)' }}
                    />
                    {/* Three horizontal lines in left panel */}
                    <line
                        x1="5"
                        y1="9"
                        x2="7.5"
                        y2="9"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <line
                        x1="5"
                        y1="12"
                        x2="7.5"
                        y2="12"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <line
                        x1="5"
                        y1="15"
                        x2="7.5"
                        y2="15"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    {/* Right-pointing chevron - appears on hover, smaller and integrated */}
                    <polyline
                        points="13,10 14.5,12 13,14"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                        opacity={isHovered ? 1 : 0}
                        style={{ transition: 'opacity 100ms cubic-bezier(0.4, 0, 0.2, 1)' }}
                    />
                </>
            )}
        </svg>
    );
};

export default DrawerIcon;

